import { render, staticRenderFns } from "./WorkflowNewTable.vue?vue&type=template&id=888ae2c8&scoped=true&"
import script from "./WorkflowNewTable.vue?vue&type=script&lang=js&"
export * from "./WorkflowNewTable.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowNewTable.vue?vue&type=style&index=0&id=888ae2c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888ae2c8",
  null
  
)

export default component.exports